// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingContext_loadingContainer__d4aaP"};